// extracted by mini-css-extract-plugin
export var actions = "_uu-4";
export var item = "_uu-1";
export var price = "_uu-3";
export var quantity = "_uu-2";
export var table = "_uu-0";